export default "__VITE_ASSET__COX13Aix__"